import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandBinanceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-binance",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 8l2 2l4 -4l4 4l2 -2l-6 -6z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 16l2 -2l4 4l3.5 -3.5l2 2l-5.5 5.5z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 10l2 2l-2 2l-2 -2z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 10l2 2l-2 2l-2 -2z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 10l2 2l-2 2l-2 -2z"
    }, null), _createTextVNode(" ")]);
  }
};